export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const FETCH_STORE = "FETCH_STORE";
export const FETCH_BRANCH = "FETCH_BRANCH";
export const SET_PRODUCT = "SET_PRODUCT";
export const SAVE_ADDRESS = "SAVE_ADDRESS";
export const SAVE_CONTACT = "SAVE_CONTACT";
export const ADD_To_CART = "ADD_To_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REDUCE_QUANTITY = "REDUCE_QUANTITY";
export const EDIT_CART = "EDIT_CART";
export const EDIT_OPTION = "EDIT_OPTION";
export const EDIT_BOOKING = "EDIT_BOOKING";
export const APPLY_PROMO = "APPLY_PROMO";
export const SET_SMART_PROMOS = "SET_SMART_PROMOS";
export const EDIT_QUANTITY = "EDIT_QUANTITY";
export const SAVE_DELIVERY_PICKUP_TIME = "SAVE_DELIVERY_PICKUP_TIME";
export const SET_PREP_TIME = "SET_PREP_TIME";
export const SAVE_PAST_ORDER = "SAVE_PAST_ORDER";
export const SET_BRANCH_DELIVERY_CHARGE = "SET_BRANCH_DELIVERY_CHARGE";
export const CLEAR_CART = "CLEAR_CART";
export const MODIFY_ADDRESS = "MODIFY_ADDRESS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const UPDATE_MOV = "UPDATE_MOV";
export const SAVE_LAST_ORDER = "SAVE_LAST_ORDER";
export const CLEAR_LAST_ORDER = "CLEAR_LAST_ORDER";
export const REDUCE_PROMO = "REDUCE_PROMO";
export const RESET_TO_INITIAL_STATE = "RESET_TO_INITIAL_STATE";
export const ADD_PROMO_ITEM = "ADD_PROMO_ITEM";
export const UPDATE_PROMOTION = "UPDATE_PROMOTION";
export const EDIT_CART_PROMO_ITEM = "EDIT_CART_PROMO_ITEM";
export const REMOVE_FROM_CART_PROMO_ITEM = "REMOVE_FROM_CART_PROMO_ITEM";
export const EDIT_QUANTITY_PROMO = "EDIT_QUANTITY_PROMO";
export const SET_CATEGORIES_MIN_ORDER = "SET_CATEGORIES_MIN_ORDER";
export const PRODUCTS_SECOND_FETCH = "PRODUCTS_SECOND_FETCH";
export const SECOND_LOADING = "SECOND_LOADING";
export const DELIVERY_CHARGES_SECOND_FETCH = "DELIVERY_CHARGES_SECOND_FETCH";
export const BRANCH_BASED_THIRD_FETCH = "BRANCH_BASED_THIRD_FETCH";
export const CATEGORY_PRODUCT_LIST_FETCH = "CATEGORY_PRODUCT_LIST_FETCH";
export const SAVE_SEARCH = "SAVE_SEARCH";
export const SAVE_CAR_INFO = "SAVE_CAR_INFO";
export const RESET_DELIVERY_TYPE = "RESET_DELIVERY_TYPE";
export const DISABLE_PROMSIE_SLOT = "DISABLE_PROMSIE_SLOT";
export const SET_PREP_AND_LEAD_TIME = "SET_PREP_AND_LEAD_TIME";
export const SET_IS_PREORDERING_FALSE = "SET_IS_PREORDERING_FALSE";
export const FETCH_DELIVERY_TIME = "FETCH_DELIVERY_TIME";
export const DELIVERY_TIME_LOADING = "DELIVERY_TIME_LOADING";
export const FETCH_STATIC_PAGES = "FETCH_STATIC_PAGES";
export const SET_USED_COMPONENTS = "SET_USED_COMPONENTS";
export const SET_NON_MINGLED_CATEGORY = "SET_NON_MINGLED_CATEGORY";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const LOAD_PRODUCT_DETAILS = "LOAD_PRODUCT_DETAILS";
export const LOAD_BRANCH_DETAILS = "LOAD_BRANCH_DETAILS";

// Profile
export const SET_USER = "SET_USER";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_USER = "UPDATE_USER";

export const LOAD_OPTIONS = "LOAD_OPTIONS";
